import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {States} from "../store/ducks/rootReducer";
import {selecionarModulo} from "../store/ducks/modulo/actions";
import {paginaDoCaminho} from "../contentRoutes";
import {moduloDaPagina, modulosVisiveis} from "./acesso";

/**
 * Modulo que o seletor e a sidebar mostram (#484909).
 *
 * A pagina aberta manda: link direto para uma tela do Financeiro abre o
 * Financeiro, mesmo que o ultimo modulo escolhido fosse outro. Sem pagina
 * (raiz), vale o escolhido, se ainda for visivel, ou o primeiro visivel.
 */
const useModuloAtual = (): string | null => {
    const dispatch = useDispatch();
    const location = useLocation();
    const acesso = useSelector((state: States) => state.login.data?.acesso);
    const escolhido = useSelector((state: States) => state.modulo.atual);

    let atual: string | null = null;
    if (acesso) {
        const pagina = paginaDoCaminho(location.pathname);
        if (pagina) {
            atual = moduloDaPagina(acesso, pagina.path, escolhido);
        }
        if (!atual) {
            const visiveis = modulosVisiveis(acesso).map(modulo => modulo.id);
            atual = escolhido && visiveis.includes(escolhido) ? escolhido : (visiveis[0] ?? null);
        }
    }

    useEffect(() => {
        if (atual && atual !== escolhido) {
            dispatch(selecionarModulo(atual));
        }
    }, [atual, escolhido, dispatch]);

    return atual;
};

export default useModuloAtual;
